import { route as confirmIdentityRoute } from "@faire/web-api--source/routes/www/confirm-identity";
import { getCurrentPath } from "@faire/web/common/Path";
import { matchPath } from "react-router-dom";

/**
 * Whether we are currently in the identity verification / confirmation flow,
 * either in the intro step or the core IDV flow.
 */
export const isIdentityVerificationRoute = (): boolean => {
  const path = getCurrentPath();
  return !!matchPath(path.pathname, confirmIdentityRoute);
};
